<section class="atw-page profile-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>

  <div class="atw-container">
    <div class="section-title">
      <span>
        <b>{{ 'profile.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'profile.title' | transloco }}</h2>
        <p>{{ 'profile.subtitle' | transloco }}</p>
      </div>
    </div>

    <div *ngIf="isLoading" class="profile-card apply-card">
      <div class="profile-loading">
        <div class="loader"></div>
        <p>{{ 'profile.loading' | transloco }}</p>
      </div>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && user" class="profile-card apply-card">
      <div class="profile-head">
        <div class="profile-avatar">
          <span>{{ profileInitial }}</span>
        </div>

        <div class="profile-main">
          <span class="hero-badge">
            <b>
              {{
                ('profile.userTypes.' + (user.user_type || 'employee'))
                  | transloco
              }}
            </b>
            {{ 'profile.employeeProfile' | transloco }}
          </span>

          <h1>{{ fullName }}</h1>

          <p>
            {{ 'profile.username' | transloco }}:
            <strong>{{ user.username }}</strong>
          </p>
        </div>

        <div class="profile-actions">
          <button
            *ngIf="!isEditing"
            type="button"
            class="profile-edit-btn"
            (click)="startEdit()"
          >
            {{ 'profile.editButton' | transloco }}
          </button>
        </div>
      </div>

      <div *ngIf="successMessage" class="success-message">
        {{ successMessage }}
      </div>

      <form
        *ngIf="isEditing"
        class="profile-edit-form"
        [formGroup]="profileForm"
        (ngSubmit)="saveProfile()"
      >
        <div class="profile-form-grid">
          <div class="profile-field">
            <label>{{ 'profile.firstName' | transloco }}</label>
            <input
              type="text"
              formControlName="first_name"
              [class.invalid]="isInvalid('first_name')"
            />
            <small *ngIf="isInvalid('first_name')">
              {{ 'profile.validation.firstNameRequired' | transloco }}
            </small>
          </div>

          <div class="profile-field">
            <label>{{ 'profile.lastName' | transloco }}</label>
            <input
              type="text"
              formControlName="last_name"
              [class.invalid]="isInvalid('last_name')"
            />
            <small *ngIf="isInvalid('last_name')">
              {{ 'profile.validation.lastNameRequired' | transloco }}
            </small>
          </div>

          <div class="profile-field">
            <label>{{ 'profile.username' | transloco }}</label>
            <input
              type="text"
              formControlName="username"
              [class.invalid]="isInvalid('username')"
            />
            <small *ngIf="isInvalid('username')">
              {{ 'profile.validation.usernameRequired' | transloco }}
            </small>
          </div>

          <div class="profile-field">
            <label>{{ 'profile.phone' | transloco }}</label>
            <input
              type="text"
              formControlName="phone"
              [class.invalid]="isInvalid('phone')"
            />
            <small *ngIf="isInvalid('phone')">
              {{ 'profile.validation.phoneMaxLength' | transloco }}
            </small>
          </div>
        </div>

        <!-- CV Upload While Editing -->
        <div class="profile-section profile-cv-edit-section">
          <h3>{{ 'profile.cv.title' | transloco }}</h3>

          <div
            class="pdf-uploader profile-cv-uploader"
            [class.drag-over]="cvDragOver"
            [class.has-file]="selectedCvFile"
            (click)="!isSaving && cvInput.click()"
            (dragover)="onCvDragOver($event)"
            (dragleave)="onCvDragLeave($event)"
            (drop)="onCvDrop($event)"
          >
            <input
              #cvInput
              type="file"
              accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.doc,.docx"
              hidden
              [disabled]="isSaving"
              (change)="onCvFileChange($event)"
            />

            <ng-container *ngIf="!selectedCvFile">
              <div class="upload-icon">
                <img
                  class="img-l"
                  src="assets/as/30.webp"
                  [alt]="'profile.cv.uploadIconAlt' | transloco"
                />
              </div>

              <h3>{{ 'profile.cv.dropTitle' | transloco }}</h3>
              <p>{{ 'profile.cv.dropText' | transloco }}</p>

              <button type="button" class="browse-btn">
                {{ 'profile.cv.chooseButton' | transloco }}
                <span>↑</span>
              </button>
            </ng-container>

            <ng-container *ngIf="selectedCvFile">
              <div class="file-preview">
                <div class="file-icon">
                  {{ getFileTypeLabel(selectedCvFile) }}
                </div>

                <div class="file-info">
                  <strong>{{ selectedCvFile.name }}</strong>
                  <span>{{ formatFileSize(selectedCvFile.size) }}</span>
                </div>

                <button
                  type="button"
                  class="remove-file"
                  [disabled]="isSaving"
                  [attr.aria-label]="'profile.cv.removeFile' | transloco"
                  (click)="removeCvFile($event)"
                >
                  ×
                </button>
              </div>
            </ng-container>
          </div>

          <small class="cv-helper-text">
            {{ 'profile.cv.optionalNote' | transloco }}
          </small>

          <div class="error-message" *ngIf="cvErrorKey">
            {{ cvErrorKey | transloco }}
          </div>

          <div class="current-cv-mini" *ngIf="currentCvUrl && !selectedCvFile">
            <span>{{ 'profile.cv.currentCv' | transloco }}</span>

            <a [href]="currentCvUrl" target="_blank" rel="noopener">
              {{ currentCvName }}
            </a>
          </div>
        </div>

        <div class="profile-form-actions">
          <button
            type="button"
            class="profile-cancel-btn secondary-btn"
            (click)="cancelEdit()"
            [disabled]="isSaving"
          >
            {{ 'profile.cancel' | transloco }}
          </button>

          <button
            type="submit"
            class="profile-save-btn"
            [disabled]="isSaving"
          >
            {{
              isSaving
                ? ('profile.saving' | transloco)
                : ('profile.saveChanges' | transloco)
            }}
          </button>
        </div>
      </form>

      <div *ngIf="!isEditing" class="profile-grid">
        <div class="profile-info-box">
          <span>{{ 'profile.firstName' | transloco }}</span>
          <strong>{{ user.first_name || '-' }}</strong>
        </div>

        <div class="profile-info-box">
          <span>{{ 'profile.lastName' | transloco }}</span>
          <strong>{{ user.last_name || '-' }}</strong>
        </div>

        <div class="profile-info-box">
          <span>{{ 'profile.phone' | transloco }}</span>
          <strong>{{ user.phone || '-' }}</strong>
        </div>
      </div>

      <!-- User CV Display -->
      <div class="profile-section profile-cv-section" *ngIf="!isEditing">
        <h3>{{ 'profile.cv.title' | transloco }}</h3>

        <div *ngIf="currentCvUrl; else noCvTemplate" class="profile-cv-card">
          <div class="profile-cv-icon">
            {{ currentCvType }}
          </div>

          <div class="profile-cv-info">
            <span>{{ 'profile.cv.savedCv' | transloco }}</span>
            <strong>{{ currentCvName }}</strong>
          </div>

          <div class="profile-cv-actions">
            <a [href]="currentCvUrl" target="_blank" rel="noopener">
              {{ 'profile.cv.open' | transloco }}
            </a>

            <a [href]="currentCvUrl" [download]="currentCvName">
              {{ 'profile.cv.download' | transloco }}
            </a>
          </div>
        </div>

        <ng-template #noCvTemplate>
          <div class="profile-no-cv">
            <strong>{{ 'profile.cv.noCvTitle' | transloco }}</strong>
            <p>{{ 'profile.cv.noCvText' | transloco }}</p>

            <div
              class="pdf-uploader profile-cv-uploader no-cv-uploader"
              [class.drag-over]="cvDragOver"
              [class.has-file]="selectedCvFile"
              (click)="!isUploadingCv && noCvInput.click()"
              (dragover)="onCvDragOver($event)"
              (dragleave)="onCvDragLeave($event)"
              (drop)="onCvDrop($event)"
            >
              <input
                #noCvInput
                type="file"
                accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.doc,.docx"
                hidden
                [disabled]="isUploadingCv"
                (change)="onCvFileChange($event)"
              />

              <ng-container *ngIf="!selectedCvFile">
                <div class="upload-icon">
                  <img
                    class="img-l"
                    src="assets/as/30.webp"
                    [alt]="'profile.cv.uploadIconAlt' | transloco"
                  />
                </div>

                <h3>{{ 'profile.cv.dropTitle' | transloco }}</h3>
                <p>{{ 'profile.cv.dropText' | transloco }}</p>

                <button type="button" class="browse-btn">
                  {{ 'profile.cv.chooseButton' | transloco }}
                  <span>↑</span>
                </button>
              </ng-container>

              <ng-container *ngIf="selectedCvFile">
                <div class="file-preview">
                  <div class="file-icon">
                    {{ getFileTypeLabel(selectedCvFile) }}
                  </div>

                  <div class="file-info">
                    <strong>{{ selectedCvFile.name }}</strong>
                    <span>{{ formatFileSize(selectedCvFile.size) }}</span>
                  </div>

                  <button
                    type="button"
                    class="remove-file"
                    [disabled]="isUploadingCv"
                    [attr.aria-label]="'profile.cv.removeFile' | transloco"
                    (click)="removeCvFile($event)"
                  >
                    ×
                  </button>
                </div>
              </ng-container>
            </div>

            <small class="cv-helper-text">
              {{ 'profile.cv.optionalNote' | transloco }}
            </small>

            <div class="error-message" *ngIf="cvErrorKey">
              {{ cvErrorKey | transloco }}
            </div>

            <button
              type="button"
              class="profile-save-btn upload-cv-btn"
              [disabled]="!selectedCvFile || isUploadingCv"
              (click)="uploadSelectedCv($event)"
            >
              {{
                isUploadingCv
                  ? ('profile.cv.uploading' | transloco)
                  : ('profile.cv.uploadNow' | transloco)
              }}
            </button>
          </div>
        </ng-template>
      </div>

      <div class="profile-section" *ngIf="user.company">
        <h3>{{ 'profile.companyData' | transloco }}</h3>

        <div class="profile-grid">
          <div class="profile-info-box">
            <span>{{ 'profile.companyName' | transloco }}</span>
            <strong>{{ user.company?.name || '-' }}</strong>
          </div>

          <div class="profile-info-box">
            <span>{{ 'profile.specialty' | transloco }}</span>
            <strong>{{ user.company?.specialty || '-' }}</strong>
          </div>

          <div class="profile-info-box">
            <span>{{ 'profile.companyPhone' | transloco }}</span>
            <strong>{{ user.company?.tel || '-' }}</strong>
          </div>
        </div>
      </div>

      <div class="profile-section" *ngIf="user.doctor">
        <h3>{{ 'profile.doctorData' | transloco }}</h3>

        <div class="profile-grid">
          <div class="profile-info-box">
            <span>{{ 'profile.doctorName' | transloco }}</span>
            <strong>{{ user.doctor?.name || '-' }}</strong>
          </div>

          <div class="profile-info-box">
            <span>{{ 'profile.specialty' | transloco }}</span>
            <strong>{{ user.doctor?.specialty || '-' }}</strong>
          </div>

          <div class="profile-info-box">
            <span>{{ 'profile.mobile' | transloco }}</span>
            <strong>{{ user.doctor?.mobile || '-' }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
